enum OriginationChannelTypeEnum {
    ONLINE = 'ONLINE',
    PHONE = 'PHONE',
}

export default OriginationChannelTypeEnum;
